import * as React from 'react';

const EyeMagnifyingGlass24 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.5 10.497a7.005 7.005 0 0 0 6.997 6.997 7.005 7.005 0 0 0 6.997-6.997A7.005 7.005 0 0 0 10.497 3.5 7.005 7.005 0 0 0 3.5 10.497Zm13.508 5.455 5.003 5.003-1.061 1.06-5.003-5.002a8.461 8.461 0 0 1-5.45 1.981 8.497 8.497 0 1 1 8.497-8.497 8.458 8.458 0 0 1-1.986 5.455ZM10.48 6.91a6 6 0 0 0-5.2 3l1.3.76a4.5 4.5 0 0 1 7.8 0l1.3-.76a6 6 0 0 0-5.2-3Zm0 2.38c-.36.002-.711.15-1.019.335a2 2 0 0 0-.731.765 1 1 0 0 1 0 1.9 2 2 0 1 0 1.75-3Z",
    clipRule: "evenodd"
  }
));
EyeMagnifyingGlass24.Size = 24;
EyeMagnifyingGlass24.Title = "EyeMagnifyingGlass";

export { EyeMagnifyingGlass24 as default };
